import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import { reducer as formReducer } from 'redux-form';
import thunkMiddleware from 'redux-thunk';
import logger from 'redux-logger';

import signupReducer from './signupReducer';
import initial from './initialReducer';
import authorizationReducer from './AuthorizationReducer';
import authenticationReducer from './AuthReducer';
import wolfConnectReducer from './WolfConnectReducer';
import linkReducer from './linkReducer';
import securityGroup from './SecurityGroupReducer';
import roster from './RosterReducer';

const AppReducer = combineReducers({
    linkReducer,
    signupReducer,
    initial,
    authorizationReducer,
    authenticationReducer,
    wolfConnectReducer,
    securityGroup,
    roster,
    form: formReducer
});

const rootReducer = (state, action) => {
    return AppReducer(state, action);
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//If this is a production build, don't include Redux Logging
const store = process.env.NODE_ENV && process.env.NODE_ENV === 'production' ? createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunkMiddleware))
) : createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunkMiddleware, logger))
);

export { store, rootReducer };